import { AssetsPurgedEvent } from '../event/assets-purged.event';
const assetsPurgedProjections = {
    [AssetsPurgedEvent.name]: (event, state) => ({
        ...state,
    }),
};
export default assetsPurgedProjections;
//# sourceMappingURL=assets-purged.projection.js.map